import * as C from '../constants';
import { useEffect, useRef, Suspense, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

export const useAnimation = (actions, names) => {
  const isChecked =
    useSelector((state: any) => state.app[C.SET_PROPELLER]) || false;
  const blades = useSelector((state: any) => state.app[C.SET_BLADES]);

  useEffect(() => {
    if (actions && names) {
      const itemKey = names[0];
      if (isChecked) {
        actions[itemKey]?.play();
      } else {
        actions[itemKey]?.stop();
      }

      names.forEach((itemKey) => {
        if (itemKey.includes(blades) && isChecked) {
          actions[itemKey]?.reset()?.play();
        } else {
          actions[itemKey]?.reset()?.stop();
        }
      });
    }
  }, [actions, names, isChecked]);

  return null;
};
